var React = require('react');

function MapInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m194.238 60.195 29.344-40.318 32.475-8.425 48.824 13.833-4.814 28.89 34.876 32.495 30.71 8.153L381.849 62.6 384.221-2l21.475 9.647 22.044 39.305 29.277 31.688 25.847 56.184 37.289 39.729L543 222.707l-2.401 55.377-39.691 68.619-25.259 60.184-35.712-1.579-27.673 9.897-43.504-23.741-16.973-24.295-14.442-26.486-30.062 6.02-58.924-18.062-50.519 12.042-67.952 22.775-44.504 19.264-39.679-15.647 1.2-34.911L0 209.37l40.891-42.133 36.077-21.668 25.259-43.335 18.033-1.202 36.689-43.252 37.289 2.415ZM401.794 449.291l12.018-14.445 43.304 2.404L435.47 483h-21.658l-12.018-33.709Z","fill":"#D1EBED"}));
}

MapInline.defaultProps = {"width":"543","height":"483","viewBox":"0 0 543 483","fill":"none"};

module.exports = MapInline;

MapInline.default = MapInline;
